import api from './client'
import netapi from './netClient'
import {  postParams} from '../lib/useParams'

export const getOrderListShortcuts = async (prm) => {
  // return api.get('order/orderConfirmationList', { params: { P_REQUEST: getParams(prm) } })
  return api.post('order/orderConfirmationList', postParams(prm), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(result => {
    return result
  })
}

export const getContractsShortcuts = async (prm) => {
  // return api.get('contract/getContractsForUser', { params: { P_REQUEST: getParams(prm) } })
  return api.post('contract/getContractsForUser', postParams(prm), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(result => {
    return result
  })
}
export const getInvoiceListShortcuts = async (prm) => {
  /*
  return api.post('invoice/list', postParams(prm), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(result => {
    return result
  })*/
  return await netapi
    .post('invoice/list', postParams(prm), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } })
    .then((result) => {
      return result
    })
}

export const getDeliveryListShortcuts = async (prm) => {
  /*
  return api.post('delivery/list', postParams(prm), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(result => {
    return result
  })*/
  return await netapi
    .post('delivery/list', postParams(prm), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } })
    .then((result) => {
      return result
    })

}
